import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=1fb6b23a"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb6b23a')) {
      api.createRecord('1fb6b23a', component.options)
    } else {
      api.reload('1fb6b23a', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=1fb6b23a", function () {
      api.rerender('1fb6b23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/downloadoverview/assets/vue/Pagination.vue"
export default component.exports